import { use } from 'react';
import { AuthContext } from './auth-context';
import type { AuthContextInterface } from './types';

/**
 * ```js
 * const {
 *   // Auth state:
 *   isAuthenticated,
 *   isLoading,
 *   access_token,
 *   id_token,
 *   error,
 *   // Auth methods:
 *   loginWithRedirect,
 *   loginWithPopup,
 *   loginWithNewTab,
 *   logout,
 * } = useAuth();
 * ```
 *
 * Use the `useAuth` hook in your components to access the auth state and methods.
 */
export default function useAuth(context = AuthContext): AuthContextInterface {
  return use(context) as AuthContextInterface;
}
